import moment from "moment";
import { useState } from "react";
import { useIntl } from "react-intl";
import { toast } from "react-toastify";
import { SimpleModal } from "src/app/components";
import Pacman from "src/app/components/layout/Pacman";
import { useGetOrderById } from "src/app/hooks";
import { OrderTransport } from "src/app/transports/order";
import { IActionsModal } from "src/app/types/actionsModal";

const IndexMeFormBodyContainer = (
    props: IActionsModal<{ id: number; url?: string | null; publishedAt?: string | null }>
) => {
    const { handleClose = () => {}, entity } = props;
    const [loading, setLoading] = useState(false);
    const { formatMessage } = useIntl();

    const { order, loading: loadingOrder } = useGetOrderById(entity.id);

    const handleSubmit = async () => {
        setLoading(true);

        try {
            await OrderTransport.indexMe(entity.id);
            toast.success(formatMessage({ id: "common.notification.success" }));
            handleClose();
        } catch (error: any) {
            toast.error(formatMessage({ id: "common.notification.error" }));
        } finally {
            setLoading(false);
        }
    };

    return (
        <SimpleModal
            entityName={formatMessage({ id: "common.entity.areYouSure" })}
            handleClose={handleClose}
            loading={loading || loadingOrder}
            formId=""
            buttonConfirmationLabel={formatMessage({ id: "common.action.confirmation" })}
            buttonConfirmationAction={handleSubmit}
            showModal={true}
            modalProps={{ size: undefined }}
        >
            {!order || loadingOrder ? (
                <Pacman />
            ) : (
                <>
                    <div className="d-flex gap-2">
                        <b className="h5">{formatMessage({ id: "common.field.url" })}:</b>
                        <span className="form-label">{order?.url}</span>
                    </div>
                    {order?.url && (
                        <div className="d-flex gap-2">
                            <b className="h5">
                                {formatMessage({ id: "common.field.publishedAt" })}:
                            </b>
                            <span className="form-label">
                                {moment(order?.publishedAt).format("DD/MM/YYYY")}
                            </span>
                        </div>
                    )}
                </>
            )}
        </SimpleModal>
    );
};

export default IndexMeFormBodyContainer;
